import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';

import { Router, RouterLink, RouterOutlet } from '@angular/router';
import { TableAction, TableColumn } from '../../shared/models/table-models';
import { Table } from '../../shared/table/table';
import { LeadService, LeadStatusActionPayload } from '../shared/service/leads.service';
import { PickListService } from '../../../core/shared/services/picklist.service';
import { PKL_GRP } from '../../../core/shared/models/picklist.model';
import { filter, take } from 'rxjs/operators';
import { forkJoin } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { Popup } from '../../../core/shared/components/popup/popup';
import { FormsModule } from '@angular/forms';
import { PermissionService } from '../../shared/services/permission.service';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';

interface Lead {
  id: number;
  clientName: string;
  contactName: string;
  phone: string;
  email: string;
  assignedTo: string;
  createdBy: string;
  status: number;
  createdDate?: string;
}

type LeadAction = 'delete' | 'reject' | 'sendBackToRO';
type LeadActionSource = 'all' | 'clientApproval' | 'pendingApproval';
type LeadTab = 'all' | 'clientApproval' | 'pendingApproval';
@Component({
  selector: 'app-lead-dashboard',

  imports: [CommonModule, Table, Popup, FormsModule, TranslatePipe],
  templateUrl: './lead-dashboard.html',
  styleUrl: './lead-dashboard.css',
})
export class LeadDashboard implements OnInit {
  leads: Lead[] = [];
  clientApprovalLeads: Lead[] = [];
  totalLeads = 0;
  newToday = 0;
  awaitingTermSheet = 0;
  awaitingApproval = 0;
  clientDecision = 0;
  openLeads = 0;
  isReviewSubmitting = false;
  pendingApprovals = 0;

  isRelationshipOfficer = false;
  showReviewPopup = false;
  leadActionComment = '';
  leadActionHistory: any[] = [];
  reviewHistory: any[] = [];
  canEditLead = false;
  reviewComment = '';
  picklists: any = {};
  columns: TableColumn[] = [];
  statusMap: Record<number, string> = {};
  popupAction: 'send' | 'approve' | null = null;
  showConfirmPopup = false;
  confirmMessage = '';
  pendingLead: Lead | null = null;
  activeTab: LeadTab = 'all';
  pendingApprovalLeads: Lead[] = [];
  showLeadActionPopup = false;
  showLeadConfirmPopup = false;
  pendingApprovalActions: TableAction[] = [];

  showRejectCommentPopup = false;
  rejectComment = '';
  rejectHistory: any[] = [];
  isRejectSubmitting = false;
  leadConfirmTitle = '';
  leadConfirmMessage = '';
  leadConfirmText = 'COMMON.CONFIRM';
  actions: TableAction[] = [];
  clientApprovalActions: TableAction[] = [];
  selectedLeadAction: LeadAction = 'sendBackToRO';
  leadActionSource: LeadActionSource = 'all';

  isLeadActionSubmitting = false;
  constructor(
    private leadService: LeadService,
    private getPicklists: PickListService,
    private router: Router,
    private toastr: ToastrService,
    public permissionService: PermissionService,
    private translate: TranslateService,
  ) {}

  ngOnInit(): void {
    const storedRole = this.currentRole;

    console.log('Stored role:', storedRole);

    this.isRelationshipOfficer = storedRole === 'LNLY_RO';

    console.log('Is RO:', this.isRelationshipOfficer);

    this.canEditLead = this.isRelationshipOfficer;
    this.buildPendingApprovalActions();
    this.buildLeadActions();
    this.buildClientApprovalActions();

    this.resetState();
    this.getLeadsCount();
    this.loadPicklists();
    this.loadClntAprlLst();
  }
  private buildClientApprovalActions(): void {
    this.clientApprovalActions = [
      {
        icon: 'images/view.png',
        tooltip: 'COMMON.VIEW',
        iconSize: 'w-4 h-4',
        class: 'bg-green-100 w-7 h-7 rounded-full flex items-center justify-center cursor-pointer',
        visible: () => true,
        onClick: (row: Lead) => this.viewLead(row),
      },
      {
        icon: 'images/Tick-2.png',
        tooltip: 'COMMON.ACCEPT',
        iconSize: 'w-6 h-6',
        class: 'bg-green-100 w-7 h-7 rounded-full flex items-center justify-center cursor-pointer',
        onClick: (row: Lead) => this.acceptLead(row),
      },
      {
        icon: 'images/cancel.png',
        tooltip: 'LEAD_DASHBOARD.CANCEL_REJECT',
        iconSize: 'w-4 h-4',
        class: 'bg-red-100 w-7 h-7 rounded-full flex items-center justify-center cursor-pointer',
        visible: () => true,
        onClick: (row: Lead) => this.openRejectCommentPopup(row, 'clientApproval'),
      },
    ];
  }
  private buildPendingApprovalActions(): void {
    this.pendingApprovalActions = [
      {
        icon: 'images/view.png',
        tooltip: 'COMMON.VIEW',
        iconSize: 'w-4 h-4',
        class: 'bg-green-100 w-7 h-7 rounded-full flex items-center justify-center cursor-pointer',
        visible: () => true,
        onClick: (row: Lead) => this.viewLead(row),
      },
      {
        icon: 'images/Tick-2.png',
        tooltip: 'COMMON.ACCEPT',
        iconSize: 'w-6 h-6',
        class: 'bg-green-100 w-7 h-7 rounded-full flex items-center justify-center cursor-pointer',
        visible: (row: Lead) => !this.isViewOnlyLead(row),
        onClick: (row: Lead) => this.sendLead(row),
      },
      {
        icon: 'images/cancel.png',
        tooltip: 'LEAD_DASHBOARD.REJECT_OR_SEND_BACK',
        iconSize: 'w-4 h-4',
        class: 'bg-red-100 w-7 h-7 rounded-full flex items-center justify-center cursor-pointer',
        visible: (row: Lead) => !this.isViewOnlyLead(row),
        onClick: (row: Lead) => this.openLeadActionPopup(row, 'pendingApproval'),
      },
    ];
  }
  openRejectCommentPopup(lead: Lead, source: 'clientApproval' | 'pendingApproval'): void {
    if (!lead?.id) {
      this.toastr.error(this.translate.instant('LEAD_DASHBOARD.INVALID_LEAD'));
      return;
    }

    this.pendingLead = lead;
    this.leadActionSource = source;
    this.rejectComment = '';
    this.rejectHistory = [];

    this.loadRejectHistory(lead.id);

    this.showRejectCommentPopup = true;
  }

  loadRejectHistory(leadSeq: number): void {
    const modSeq = localStorage.getItem('modSeq') ?? '2';

    this.leadService.getOnboardingReview(leadSeq, modSeq).subscribe({
      next: (res: any) => {
        this.rejectHistory = res?.data || res || [];
      },
      error: () => {
        this.rejectHistory = [];
      },
    });
  }

  private get currentModSeq(): number {
    return Number(localStorage.getItem('modSeq') ?? 2);
  }

  /**
   * Comment ab yahin se seedha rejectLead / INTERNAL_REJECT ke payload mein
   * jata hai — saveOnboardingReview ki alag call ki zaroorat nahi.
   */
  submitRejectComment(): void {
    if (!this.pendingLead || this.isRejectSubmitting) {
      return;
    }

    if (!this.rejectComment.trim()) {
      this.toastr.error(this.translate.instant('LEAD_DASHBOARD.ENTER_REJECT_COMMENT'));
      return;
    }

    if (this.rejectComment.length > 5000) {
      this.toastr.error(this.translate.instant('LEAD_DASHBOARD.COMMENT_MAX_LENGTH'));
      return;
    }

    this.isRejectSubmitting = true;

    this.finalRejectLeadWithComment();
  }

  private finalRejectLeadWithComment(): void {
    if (!this.pendingLead) {
      this.isRejectSubmitting = false;
      return;
    }

    const lead = this.pendingLead;

    const payload: LeadStatusActionPayload = {
      entySeq: lead.id,
      entyType: this.currentModSeq,
      cmmnt: this.rejectComment.trim(),
    };

    const request$ =
      this.leadActionSource === 'clientApproval'
        ? this.leadService.rejectLead(payload)
        : this.leadService.INTERNAL_REJECT(payload);

    request$.subscribe({
      next: (res: any) => {
        if (res?.error || res?.__hasError) {
          this.toastr.error(res?.error || res?.message || this.translate.instant('LEAD_DASHBOARD.UNABLE_TO_REJECT_LEAD'));
          this.isRejectSubmitting = false;
          return;
        }

        this.toastr.success(this.translate.instant('LEAD_DASHBOARD.LEAD_REJECTED_SUCCESSFULLY'));

        this.clientApprovalLeads = this.clientApprovalLeads.filter((l) => l.id !== lead.id);
        this.pendingApprovalLeads = this.pendingApprovalLeads.filter((l) => l.id !== lead.id);
        this.leads = this.leads.filter((l) => l.id !== lead.id);

        this.getLeads();
        this.getLeadsCount();
        this.loadClntAprlLst();

        this.closeRejectCommentPopup();
      },
      error: (err) => {
        this.toastr.error(err?.error?.error || err?.error?.message || this.translate.instant('LEAD_DASHBOARD.FAILED_TO_REJECT_LEAD'));
        this.isRejectSubmitting = false;
      },
    });
  }
  private saveReviewBeforeAction(
    leadSeq: number,
    comment: string,
    onSaved: () => void,
    onFailed?: () => void,
  ): void {
    const payload = {
      entySeq: leadSeq,
      entyType: localStorage.getItem('modSeq') ?? 2,
      clntSeq: null,
      cmmnt: comment?.trim() || '',
    };

    this.leadService.saveOnboardingReview(payload).subscribe({
      next: (reviewRes: any) => {
        if (
          reviewRes?.error ||
          reviewRes?.__hasError ||
          reviewRes?.success === false ||
          reviewRes?.status === false
        ) {
          this.toastr.error(
            reviewRes?.message || reviewRes?.error || this.translate.instant('LEAD_DASHBOARD.FAILED_TO_SUBMIT_REVIEW'),
          );

          if (onFailed) onFailed();
          return;
        }

        onSaved();
      },
      error: (err) => {
        this.toastr.error(
          err?.error?.error || err?.error?.message || this.translate.instant('LEAD_DASHBOARD.FAILED_TO_SUBMIT_REVIEW'),
        );

        if (onFailed) onFailed();
      },
    });
  }
  closeRejectCommentPopup(): void {
    this.showRejectCommentPopup = false;
    this.rejectComment = '';
    this.rejectHistory = [];
    this.isRejectSubmitting = false;
    this.pendingLead = null;
    this.leadActionSource = 'all';
  }
  /*
   * Pending approval queue mapping
   *
   * LNLY_RO does not see the Pending Approvals tab.
   * LNLY_SA can see every approval status.
   *
   * No pending approval status was provided for LNLY_BB or LNLY_VPF,
   * therefore their arrays remain empty until a status is confirmed.
   * LNLY_CRCO is included because status 2557 is specified as CRCO approval pending.
   */
  private readonly allPendingApprovalStatuses: number[] = [
    600, // Pending approval Team Lead
    601, // Pending approval Dept Head
    604, // Pending VCM Approval
    2502, // Team Lead approval Pending
    2503, // Department Head approval Pending
    2504, // Compliance Officer approval Pending
    2505, // Compliance Manager approval Pending
    2556, // Vice Compliance Manager approval Pending
    2557, // CRCO approval Pending
  ];

  private readonly rolePendingApprovalStatuses: Record<string, number[]> = {
    LNLY_BB: [],
    LNLY_CM: [2505],
    LNLY_CO: [2504],
    LNLY_PMDH: [601, 2503],
    LNLY_RO: [],
    LNLY_SA: [...this.allPendingApprovalStatuses],
    LNLY_TL: [600, 2502],
    LNLY_VCM: [604, 2556],
    LNLY_VPF: [],

    // Included for CRCO approval status 2557.
    LNLY_CRCO: [2557],
  };

  private readonly hardcodedPendingStatusLabels: Record<number, string> = {
    600: 'LEAD_DASHBOARD.STATUS_600',
    601: 'LEAD_DASHBOARD.STATUS_601',
    604: 'LEAD_DASHBOARD.STATUS_604',
    2502: 'LEAD_DASHBOARD.STATUS_2502',
    2503: 'LEAD_DASHBOARD.STATUS_2503',
    2504: 'LEAD_DASHBOARD.STATUS_2504',
    2505: 'LEAD_DASHBOARD.STATUS_2505',
    2556: 'LEAD_DASHBOARD.STATUS_2556',
    2557: 'LEAD_DASHBOARD.STATUS_2557',
  };

  /*
   * Status labels can come from all three groups:
   * 15 = lead statuses, 23 = onboarding statuses, 26 = pending/workflow statuses.
   */
  private readonly leadStatusGroups = [
    PKL_GRP.LEADS_STATUS,
    PKL_GRP.ONBOARDING_STATUS,
    PKL_GRP.PANDDING_STATUS,
  ];

  private readonly viewOnlyLeadsStatuses = new Set<number>([2554, 665]);

  isViewOnlyLead(lead: Lead): boolean {
    return this.viewOnlyLeadsStatuses.has(Number(lead.status));
  }

  /*
  * Show edit/delete icons for RO only when the 
  * lead is in an editable stage; show only the 
  * view icon for all other `stsKey` values.
  */
  private readonly roEditDeleteAllowedStatuses = new Set<number>([2553, 799]);
  isRoEditDeleteAllowed(lead: Lead): boolean {
    return this.roEditDeleteAllowedStatuses.has(Number(lead.status));
  }

  get currentRole(): string {
    return (localStorage.getItem('role') || localStorage.getItem('user_role') || '')
      .trim()
      .toUpperCase();
  }

  get canViewPendingApprovals(): boolean {
    return this.currentRole !== 'LNLY_RO';
  }

  private getAllowedPendingApprovalStatuses(): number[] {
    return this.rolePendingApprovalStatuses[this.currentRole] || [];
  }

  private loadPendingApprovalLeads(): void {
    const allowedStatuses = this.getAllowedPendingApprovalStatuses();

    this.pendingApprovalLeads = this.leads.filter((lead) =>
      allowedStatuses.includes(Number(lead.status)),
    );
  }
  resetState(): void {
    this.leads = [];
    this.clientApprovalLeads = [];
    this.pendingApprovalLeads = [];
    this.selectedLeads = [];

    this.totalLeads = 0;
    this.newToday = 0;
    this.awaitingTermSheet = 0;
    this.awaitingApproval = 0;
    this.clientDecision = 0;
    this.openLeads = 0;
    this.pendingApprovals = 0;
  }

  loadPicklists(): void {
    this.getPicklists.loadCodes(this.leadStatusGroups);

    /*
     * Do not require every group to be non-empty.
     * Group 23 may be absent from the current backend response; waiting for it
     * would stop the whole Leads dashboard from loading.
     */
    this.getPicklists.picklists$
      .pipe(
        filter((picklists: any) =>
          this.leadStatusGroups.some(
            (group) => this.getPicklistOptions(group, picklists).length > 0,
          ),
        ),
        take(1),
      )
      .subscribe((picklists: any) => {
        this.statusMap = this.getLeadStatusMap(picklists);

        console.log('Lead / onboarding / pending status map:', this.statusMap);
        console.log(
          'Onboarding status group (23):',
          this.getPicklistOptions(PKL_GRP.ONBOARDING_STATUS, picklists),
        );

        this.buildColumns();
        this.getLeads();
      });
  }

  setTab(tab: LeadTab): void {
    this.activeTab = tab;
  }
  private getPicklistOptions(group: number, picklists?: any): any[] {
    /*
     * Supports both PickListService formats:
     * - raw API rows: { refCdSeq, refCd, refCdDscr }
     * - dropdown options: { value, label, original }
     */
    const emittedOptions = picklists?.[String(group)] ?? picklists?.[group];

    if (Array.isArray(emittedOptions)) {
      return emittedOptions;
    }

    const syncedOptions = this.getPicklists.getOptionsSync(group);

    return Array.isArray(syncedOptions) ? syncedOptions : [];
  }

  private getLeadStatusMap(picklists?: any): Record<number, string> {
    const map: Record<number, string> = {
      ...this.hardcodedPendingStatusLabels,
    };

    this.leadStatusGroups.forEach((group) => {
      const options = this.getPicklistOptions(group, picklists);

      options.forEach((option: any) => {
        const label = option?.label ?? option?.refCdDscr ?? option?.original?.refCdDscr ?? '';

        /*
         * Register every possible status key.
         * Example: group 26 can return refCdSeq=702 and refCd='902'
         * for the label 'Approved'. Both 702 and 902 must resolve.
         */
        const keys = [
          option?.value,
          option?.refCdSeq,
          option?.refCd,
          option?.original?.value,
          option?.original?.refCdSeq,
          option?.original?.refCd,
        ];

        keys.forEach((key) => {
          if (key === null || key === undefined || String(key).trim() === '' || !label) {
            return;
          }

          const numericKey = Number(key);

          if (!Number.isNaN(numericKey)) {
            map[numericKey] = String(label);
          }
        });
      });
    });

    return map;
  }

  private addMissingStatusFallbacks(rows: Lead[]): void {
    rows.forEach((row) => {
      const status = Number(row.status);

      if (!Number.isNaN(status) && !this.statusMap[status]) {
        this.statusMap[status] = this.translate.instant('LEAD_DASHBOARD.UNKNOWN_STATUS', { status });
      }
    });
  }

  private refreshStatusColumnMap(): void {
    this.columns = this.columns.map((column) =>
      column.key === 'status'
        ? {
            ...column,
            map: { ...this.statusMap },
          }
        : column,
    );
  }

  loadClntAprlLst(): void {
    this.leadService.getClientApprovalLeads().subscribe({
      next: (res: any) => {
        let raw: any[] = [];

        const maybeData = res?.data ?? res;

        if (Array.isArray(maybeData)) {
          raw = maybeData;
        } else if (maybeData && typeof maybeData === 'object') {
          // try common keys
          if (Array.isArray(maybeData.data)) {
            raw = maybeData.data;
          } else if (Array.isArray(maybeData.items)) {
            raw = maybeData.items;
          } else if (Array.isArray(maybeData.leads)) {
            raw = maybeData.leads;
          } else {
            const firstArray = Object.values(maybeData).find((v) => Array.isArray(v));
            if (Array.isArray(firstArray)) raw = firstArray;
          }
        }

        if (!Array.isArray(raw)) raw = [];

        this.clientApprovalLeads = raw.map((item: any) => ({
          id: item.leadSeq,
          clientName: item.clntNm,
          contactName: item.cntctNm,
          phone: item.cntctNum?.toString(),
          email: item.cntctEmail,
          assignedTo: item.pendingWithNm,
          createdBy: item.crtdBy,
          status: item.stsKey,
          createdDate: item.crtdDt,
        }));

        this.addMissingStatusFallbacks(this.clientApprovalLeads);
        this.refreshStatusColumnMap();

        console.log('clientApprovalLeads', this.clientApprovalLeads);
      },
    });
  }
  buildColumns(): void {
    this.translate
      .get([
        'LEAD_DASHBOARD.CLIENT_NAME',
        'LEAD_DASHBOARD.CONTACT_NAME',
        'LEAD_DASHBOARD.CONTACT_PHONE',
        'LEAD_DASHBOARD.CONTACT_EMAIL',
        'LEAD_DASHBOARD.ASSIGNED_TO',
        'LEAD_DASHBOARD.CREATED_BY',
        'LEAD_DASHBOARD.STATUS',
      ])
      .subscribe((t) => {
        this.columns = [
          {
            key: 'clientName',
            label: t['LEAD_DASHBOARD.CLIENT_NAME'],
          },
          {
            key: 'contactName',
            label: t['LEAD_DASHBOARD.CONTACT_NAME'],
          },
          {
            key: 'phone',
            label: t['LEAD_DASHBOARD.CONTACT_PHONE'],
          },
          {
            key: 'email',
            label: t['LEAD_DASHBOARD.CONTACT_EMAIL'],
          },
          {
            key: 'assignedTo',
            label: t['LEAD_DASHBOARD.ASSIGNED_TO'],
          },
          {
            key: 'createdBy',
            label: t['LEAD_DASHBOARD.CREATED_BY'],
          },
          {
            key: 'status',
            label: t['LEAD_DASHBOARD.STATUS'],
            type: 'map',
            map: { ...this.statusMap },
          },
        ];
      });
  }

  getLeads(): void {
    this.leadService.getLeadList().subscribe({
      next: (res: any) => {
        const maybeData = res?.data ?? res;

        // Normalize response to an array to avoid runtime errors when backend returns
        // an object or unexpected structure.
        let rawLeads: any[] = [];

        if (Array.isArray(maybeData)) {
          rawLeads = maybeData;
        } else if (maybeData && typeof maybeData === 'object') {
          // common payload shapes: { data: [...] } or { leads: [...] }
          if (Array.isArray(maybeData.leads)) {
            rawLeads = maybeData.leads;
          } else if (Array.isArray(maybeData.items)) {
            rawLeads = maybeData.items;
          } else if (Array.isArray(maybeData.data)) {
            rawLeads = maybeData.data;
          } else {
            // fallback: find first array-valued property
            const firstArray = Object.values(maybeData).find((v) => Array.isArray(v));
            if (Array.isArray(firstArray)) rawLeads = firstArray as any[];
          }
        }

        if (!Array.isArray(rawLeads)) rawLeads = [];

        if (rawLeads.length === 0 && maybeData && !Array.isArray(maybeData)) {
          console.warn('Unexpected leads response shape', maybeData);
        }

        this.leads = rawLeads.map(
          (item: any): Lead => ({
            id: Number(item.leadSeq),
            clientName: item.clntNm,
            contactName: item.cntctNm,
            phone: item.cntctNum?.toString(),
            email: item.cntctEmail,
            assignedTo: item.pendingWithNm,
            createdBy: item.crtdBy,
            status: Number(item.stsKey),
            createdDate: item.crtdDt,
          }),
        );

        this.addMissingStatusFallbacks(this.leads);
        this.refreshStatusColumnMap();

        this.loadPendingApprovalLeads();
        this.calculateStats();
      },
      error: () => {
        this.leads = [];
        this.pendingApprovalLeads = [];
        this.pendingApprovals = 0;
      },
    });
  }

  getPicklistMap(groupCode: number): Record<number, string> {
    const map: Record<number, string> = {};

    this.getPicklistOptions(groupCode).forEach((option: any) => {
      const label = option?.label ?? option?.refCdDscr ?? option?.original?.refCdDscr ?? '';

      [
        option?.value,
        option?.refCdSeq,
        option?.refCd,
        option?.original?.refCdSeq,
        option?.original?.refCd,
      ].forEach((key) => {
        const numericKey = Number(key);

        if (!Number.isNaN(numericKey) && label) {
          map[numericKey] = String(label);
        }
      });
    });

    return map;
  }

  getLeadsCount(): void {
    this.leadService.getAllLeadsCount().subscribe({
      next: (res: any) => {
        // ✅ Map API → UI variables
        this.newToday = res?.todayLeads || 0;

        this.awaitingTermSheet = res?.msngTrmSheetLeads || 0;

        this.awaitingApproval = res?.teamLeadAprvlLeads || 0;

        this.clientDecision = res?.clntAprvlLeads || 0;

        // Pending approval count is role-specific and is calculated from getLeadList().
        this.pendingApprovals = this.pendingApprovalLeads.length;

        // optional (not in API directly)
        this.openLeads = res?.drftLeads || 0;

        // total (optional)
        this.totalLeads =
          this.newToday +
          this.awaitingTermSheet +
          this.awaitingApproval +
          this.clientDecision +
          this.pendingApprovals +
          this.openLeads;
      },
      error: (err) => {
        console.error('Error fetching leads count', err);
      },
    });
  }

  calculateStats(): void {
    if (!this.leads.length) {
      this.totalLeads = 0;
      this.newToday = 0;
      this.awaitingTermSheet = 0;
      this.awaitingApproval = 0;
      this.clientDecision = 0;
      this.openLeads = 0;
      this.pendingApprovals = 0;
      return;
    }

    this.totalLeads = this.leads.length;

    const today = new Date().toDateString();

    const TERM_SHEET_PENDING = this.getStatusKey('TERM_SHEET_PENDING');
    const APPROVAL_PENDING = this.getStatusKey('APPROVAL_PENDING');
    const CLIENT_DECISION = this.getStatusKey('CLIENT_DECISION');
    const ACTIVE = this.getStatusKey('Active');

    this.newToday = this.leads.filter(
      (l) => new Date((l as any).createdDate).toDateString() === today,
    ).length;

    this.awaitingTermSheet = this.leads.filter((l) => l.status === TERM_SHEET_PENDING).length;

    this.awaitingApproval = this.leads.filter((l) => l.status === APPROVAL_PENDING).length;

    this.clientDecision = this.leads.filter((l) => l.status === CLIENT_DECISION).length;

    this.openLeads = this.leads.filter((l) => l.status === ACTIVE).length;

    this.pendingApprovals = this.pendingApprovalLeads.length;
  }
  getStatusKey(label: string): number | undefined {
    for (const group of this.leadStatusGroups) {
      const option = this.getPicklistOptions(group).find((item: any) => {
        const optionLabel = item?.label ?? item?.refCdDscr ?? item?.original?.refCdDscr ?? '';

        return String(optionLabel).trim().toLowerCase() === label.trim().toLowerCase();
      });

      if (option) {
        const statusKey = Number(
          option?.value ??
            option?.refCdSeq ??
            option?.refCd ??
            option?.original?.refCdSeq ??
            option?.original?.refCd,
        );

        if (!Number.isNaN(statusKey)) {
          return statusKey;
        }
      }
    }

    return undefined;
  }

  private buildLeadActions(): void {
    this.actions = [
      {
        icon: 'images/edit.png',
        tooltip: 'LEAD_DASHBOARD.EDIT_LEADS',
        iconSize: 'w-4 h-4',
        class: 'bg-blue-100 w-7 h-7 rounded-full flex items-center justify-center cursor-pointer',
        visible: (row: Lead) => this.isRelationshipOfficer && this.isRoEditDeleteAllowed(row),
        onClick: (row: Lead) => this.editLead(row),
      },
      {
        icon: 'images/view.png',
        tooltip: 'COMMON.VIEW',
        iconSize: 'w-4 h-4',
        class: 'bg-green-100 w-7 h-7 rounded-full flex items-center justify-center cursor-pointer',
        visible: () => true,
        onClick: (row: Lead) => this.viewLead(row),
      },
      {
        icon: 'images/cancel.png',
        tooltip: 'LEAD_DASHBOARD.DELETE_LEAD',
        iconSize: 'w-4 h-4',
        class: 'bg-red-100 w-7 h-7 rounded-full flex items-center justify-center cursor-pointer',
        visible: (row: Lead) => this.isRelationshipOfficer && this.isRoEditDeleteAllowed(row),
        onClick: (row: Lead) => this.openLeadActionPopup(row, 'all'),
      },
    ];
  }

  // ================= LEADS DATA =================

  editLead(lead: Lead): void {
    if (!this.canEditLead) {
      this.toastr.error(this.translate.instant('LEAD_DASHBOARD.ONLY_RO_CAN_EDIT_LEADS'));
      return;
    }

    if (!this.isRoEditDeleteAllowed(lead)) {
      this.toastr.warning(this.translate.instant('LEAD_DASHBOARD.LEAD_VIEW_ONLY'));
      return;
    }

    this.router.navigate(['/add-new-leads/demographic', lead.id]);
  }

  viewLead(lead: Lead): void {
    this.router.navigate(['/add-new-leads/demographic', lead.id], {
      queryParams: { mode: 'view' },
    });
  }

  selectedLeads: any[] = [];

  onSelectionChange(selected: any[]) {
    this.selectedLeads = selected;
  }
  sendSelectedLeads(): void {
    if (!this.selectedLeads.length) {
      console.warn('No leads selected');
      return;
    }

    const entyType = this.currentModSeq;

    const requests = this.selectedLeads.map((lead) => {
      const payload: LeadStatusActionPayload = {
        entySeq: lead.leadSeq,
        entyType,
        cmmnt: '',
      };

      return this.leadService.updateLeadStatus(payload);
    });

    // execute all API calls
    forkJoin(requests).subscribe({
      next: (res) => {
        console.log('All leads sent successfully', res);

        // update UI
        this.selectedLeads.forEach((l) => (l.stsKey = 2));

        // clear selection (optional)
        this.selectedLeads = [];
      },
      error: (err) => {
        console.error('Error sending leads', err);
      },
    });
  }

  prepareLeadActionConfirmation(): void {
    if (!this.pendingLead) {
      return;
    }

    this.showLeadActionPopup = false;
    this.openLeadConfirmation();
  }

  private openLeadConfirmation(): void {
    const lead = this.pendingLead;

    if (!lead) {
      return;
    }

    const leadLabel = lead.clientName || this.translate.instant('LEAD_DASHBOARD.LEAD_NUMBER', { id: lead.id });

    if (this.selectedLeadAction === 'delete') {
      this.leadConfirmTitle = 'LEAD_DASHBOARD.DELETE_LEAD';
      this.leadConfirmText = 'COMMON.DELETE';
      this.leadConfirmMessage = this.translate.instant('LEAD_DASHBOARD.CONFIRM_DELETE_LEAD', {
        name: leadLabel,
      });
    } else if (this.selectedLeadAction === 'sendBackToRO') {
      this.leadConfirmTitle = 'LEAD_DASHBOARD.SEND_BACK_TO_RO';
      this.leadConfirmText = 'COMMON.SEND_BACK';
      this.leadConfirmMessage = this.translate.instant('LEAD_DASHBOARD.CONFIRM_SEND_BACK_LEAD', {
        name: leadLabel,
      });
    } else {
      this.leadConfirmTitle = 'LEAD_DASHBOARD.PERMANENT_REJECT';
      this.leadConfirmText = 'COMMON.REJECT';
      this.leadConfirmMessage = this.translate.instant('LEAD_DASHBOARD.CONFIRM_PERMANENT_REJECT_LEAD', {
        name: leadLabel,
      });
    }

    this.leadActionComment = '';
    this.leadActionHistory = [];

    if (this.leadActionSource === 'pendingApproval' && this.selectedLeadAction !== 'delete') {
      this.loadLeadActionHistory(lead.id);
    }

    this.showLeadConfirmPopup = true;
  }
  loadLeadActionHistory(leadSeq: number): void {
    const modSeq = localStorage.getItem('modSeq') ?? '2';

    this.leadService.getOnboardingReview(leadSeq, modSeq).subscribe({
      next: (res: any) => {
        this.leadActionHistory = res?.data || res || [];
      },
      error: () => {
        this.leadActionHistory = [];
      },
    });
  }
  /**
   * Comment ab saveReviewBeforeAction ki alag call ke bagair
   * seedha processLeadActionRequest ke payload mein bhej dete hain
   * (sendBackToRO / reject / internal-reject ke liye).
   */
  confirmLeadAction(): void {
    if (!this.pendingLead || this.isLeadActionSubmitting) {
      return;
    }

    const lead = this.pendingLead;
    const action = this.selectedLeadAction;

    const shouldSaveComment = this.leadActionSource === 'pendingApproval' && action !== 'delete';

    if (shouldSaveComment && !this.leadActionComment.trim()) {
      this.toastr.warning(this.translate.instant('LEAD_DASHBOARD.PLEASE_ADD_COMMENT'));
      return;
    }

    if (shouldSaveComment && this.leadActionComment.length > 5000) {
      this.toastr.error(this.translate.instant('LEAD_DASHBOARD.COMMENT_MAX_LENGTH'));
      return;
    }

    this.isLeadActionSubmitting = true;

    this.processLeadActionRequest(lead, action);
  }
  private processLeadActionRequest(lead: Lead, action: LeadAction): void {
    let request$;

    if (action === 'delete') {
      const payload = {
        leadSeq: lead.id,
        delFlg: 1,
      };

      request$ = this.leadService.saveLead(payload);
    } else {
      const actionPayload: LeadStatusActionPayload = {
        entySeq: lead.id,
        entyType: this.currentModSeq,
        cmmnt: this.leadActionComment.trim(),
      };

      if (action === 'sendBackToRO') {
        request$ = this.leadService.sendLeadBackToRO(actionPayload);
      } else {
        request$ =
          this.leadActionSource === 'clientApproval'
            ? this.leadService.rejectLead(actionPayload)
            : this.leadService.INTERNAL_REJECT(actionPayload);
      }
    }

    request$.subscribe({
      next: (res: any) => {
        if (res?.error || res?.__hasError || res?.success === false || res?.status === false) {
          this.toastr.error(res?.error || res?.message || this.translate.instant('LEAD_DASHBOARD.UNABLE_TO_PROCESS_LEAD'));
          this.isLeadActionSubmitting = false;
          return;
        }

        const successMessage =
          action === 'delete'
            ? this.translate.instant('LEAD_DASHBOARD.LEAD_DELETED_SUCCESSFULLY')
            : action === 'sendBackToRO'
              ? this.translate.instant('LEAD_DASHBOARD.REVIEW_SUBMITTED_SENT_BACK')
              : this.translate.instant('LEAD_DASHBOARD.REVIEW_SUBMITTED_REJECTED');

        this.toastr.success(successMessage);

        this.getLeads();
        this.getLeadsCount();
        this.loadClntAprlLst();

        this.resetLeadActionState();
        this.leadActionComment = '';
        this.leadActionHistory = [];
      },
      error: (err) => {
        this.toastr.error(err?.error?.error || err?.error?.message || this.translate.instant('LEAD_DASHBOARD.UNABLE_TO_PROCESS_LEAD'));
        this.isLeadActionSubmitting = false;
      },
    });
  }
  private saveLeadActionReviewAfterSuccess(
    leadSeq: number,
    comment: string,
    successMessage: string,
  ): void {
    const payload = {
      entySeq: leadSeq,
      entyType: localStorage.getItem('modSeq') ?? 2,
      clntSeq: null,
      cmmnt: comment,
    };

    this.leadService.saveOnboardingReview(payload).subscribe({
      next: (reviewRes: any) => {
        if (
          reviewRes?.error ||
          reviewRes?.__hasError ||
          reviewRes?.success === false ||
          reviewRes?.status === false
        ) {
          this.toastr.error(
            reviewRes?.message || reviewRes?.error || this.translate.instant('LEAD_DASHBOARD.LEAD_PROCESSED_COMMENT_FAILED'),
          );

          this.isLeadActionSubmitting = false;
          return;
        }

        this.toastr.success(successMessage);

        this.getLeads();
        this.getLeadsCount();
        this.loadClntAprlLst();

        this.resetLeadActionState();
        this.leadActionComment = '';
        this.leadActionHistory = [];
      },
      error: (err) => {
        this.toastr.error(
          err?.error?.error || err?.error?.message || this.translate.instant('LEAD_DASHBOARD.LEAD_PROCESSED_COMMENT_FAILED'),
        );

        this.isLeadActionSubmitting = false;
      },
    });
  }
  closeLeadActionPopup(): void {
    this.resetLeadActionState();
  }

  private resetLeadActionState(): void {
    this.showLeadActionPopup = false;
    this.showLeadConfirmPopup = false;

    this.pendingLead = null;
    this.leadActionSource = 'all';
    this.selectedLeadAction = 'sendBackToRO';
    this.isLeadActionSubmitting = false;
  }

  sendLead(lead: Lead): void {
    if (!lead?.id) {
      this.toastr.error(this.translate.instant('LEAD_DASHBOARD.LEAD_ID_MISSING'));

      return;
    }

    this.pendingLead = lead;

    this.popupAction = 'send';

    this.reviewComment = '';

    this.loadReviewHistory(lead.id);

    this.showReviewPopup = true;
  }

  acceptLead(lead: Lead): void {
    if (!lead?.id) {
      this.toastr.error(this.translate.instant('LEAD_DASHBOARD.INVALID_LEAD'));

      return;
    }

    this.pendingLead = lead;

    this.popupAction = 'approve';

    this.reviewComment = '';

    this.loadReviewHistory(lead.id);

    this.showReviewPopup = true;
  }
  /**
   * "send" action ka comment seedha updateLeadStatus ke payload mein jata
   * hai. "approve" endpoint (/leads/apprv-lead/{leadSeq}) khud comment
   * accept nahi karta (sirf leadSeq), isliye approve ke liye comment pehle
   * saveOnboardingReview se save hota hai, phir leadApproved call hoti hai.
   */
  submitReviewComment(): void {
  if (
    !this.pendingLead ||
    this.isReviewSubmitting
  ) {
    return;
  }

  if (!this.popupAction) {
    this.toastr.error(this.translate.instant('LEAD_DASHBOARD.ACTION_MISSING'));
    return;
  }

  if (!this.reviewComment.trim()) {
    this.toastr.warning(
      this.translate.instant('LEAD_DASHBOARD.PLEASE_ADD_COMMENT'),
    );
    return;
  }

  if (this.reviewComment.length > 5000) {
    this.toastr.error(
      this.translate.instant('LEAD_DASHBOARD.COMMENT_MAX_LENGTH'),
    );
    return;
  }

  this.isReviewSubmitting = true;

  if (this.popupAction === 'send') {
    this.finalSendLead();
    return;
  }

  if (this.popupAction === 'approve') {
    this.finalApproveLead();
  }
}
  private resetReviewState(): void {
    this.showReviewPopup = false;
    this.reviewComment = '';
    this.reviewHistory = [];
    this.pendingLead = null;
    this.popupAction = null;
    this.isReviewSubmitting = false;
  }
  private saveReviewAfterSuccess(
    leadSeq: number,
    comment: string,
    successMessage: string,
    afterSuccess?: () => void,
  ): void {
    const payload = {
      entySeq: leadSeq,
      entyType: localStorage.getItem('modSeq') ?? 2,
      clntSeq: null,
      cmmnt: comment || '',
    };

    this.leadService.saveOnboardingReview(payload).subscribe({
      next: (reviewRes: any) => {
        if (
          reviewRes?.error ||
          reviewRes?.__hasError ||
          reviewRes?.success === false ||
          reviewRes?.status === false
        ) {
          this.toastr.error(
            reviewRes?.message ||
              reviewRes?.error ||
              this.translate.instant('LEAD_DASHBOARD.LEAD_PROCESSED_REVIEW_COMMENT_FAILED'),
          );
          return;
        }

        this.toastr.success(successMessage);

        this.showReviewPopup = false;
        this.reviewComment = '';
        this.pendingLead = null;
        this.popupAction = null;

        if (afterSuccess) {
          afterSuccess();
        }
      },
      error: (err) => {
        this.toastr.error(
          err?.error?.error ||
            err?.error?.message ||
            this.translate.instant('LEAD_DASHBOARD.LEAD_PROCESSED_REVIEW_COMMENT_FAILED'),
        );
      },
    });
  }

  loadReviewHistory(leadSeq: number): void {
    const modSeq = localStorage.getItem('modSeq') ?? '2';

    this.leadService.getOnboardingReview(leadSeq, modSeq).subscribe({
      next: (res: any) => {
        this.reviewHistory = res?.data || res || [];
      },
      error: () => {
        this.reviewHistory = [];
      },
    });
  }
  // ✅ User ne "Yes" dabaya — actual send karo
  onSendConfirmed(): void {
    if (!this.pendingLead) return;

    const lead = this.pendingLead;

    const payload: LeadStatusActionPayload = {
      entySeq: lead.id,
      entyType: this.currentModSeq,
      cmmnt: '',
    };

    this.leadService.updateLeadStatus(payload).subscribe({
      next: (res: any) => {
        if (res?.__hasError) return;

        lead.status = 2;
        this.toastr.success(this.translate.instant('LEAD_DASHBOARD.LEAD_SENT_SUCCESSFULLY'));
        this.getLeads();
        this.getLeadsCount();
      },
      error: () => {
        this.toastr.error(this.translate.instant('LEAD_DASHBOARD.NETWORK_SERVER_ERROR'));
      },
    });

    this.pendingLead = null;
  }

  openLeadActionPopup(lead: Lead, source: LeadActionSource): void {
    if (!lead?.id) {
      this.toastr.error(this.translate.instant('LEAD_DASHBOARD.INVALID_LEAD'));
      return;
    }

    this.pendingLead = lead;
    this.leadActionSource = source;

    // RO can only delete from All Leads
    if (this.isRelationshipOfficer && source === 'all') {
      this.selectedLeadAction = 'delete';
      this.openLeadConfirmation();
      return;
    }

    // Pending Approval / Client Approval users can choose action
    this.selectedLeadAction = 'sendBackToRO';
    this.showLeadActionPopup = true;
  }

  submitLeadAction(): void {
    if (!this.pendingLead || this.isLeadActionSubmitting) {
      return;
    }
    if (this.isRelationshipOfficer && this.selectedLeadAction === 'sendBackToRO') {
      this.selectedLeadAction = 'reject';
    }
    this.isLeadActionSubmitting = true;

    const lead = this.pendingLead;

    const payload: LeadStatusActionPayload = {
      entySeq: lead.id,
      entyType: this.currentModSeq,
      cmmnt: this.leadActionComment?.trim() || '',
    };

    const request$ =
      this.selectedLeadAction === 'reject'
        ? this.leadService.INTERNAL_REJECT(payload)
        : this.leadService.sendLeadBackToRO(payload);

    request$.subscribe({
      next: (res: any) => {
        if (res?.error || res?.__hasError) {
          this.toastr.error(res?.error || res?.message || this.translate.instant('LEAD_DASHBOARD.UNABLE_TO_PROCESS_LEAD'));
          this.isLeadActionSubmitting = false;
          return;
        }

        const message =
          this.selectedLeadAction === 'reject'
            ? this.translate.instant('LEAD_DASHBOARD.LEAD_REJECTED_SUCCESSFULLY')
            : this.translate.instant('LEAD_DASHBOARD.LEAD_SENT_BACK_SUCCESSFULLY');

        this.toastr.success(message);

        this.getLeads();
        this.getLeadsCount();
        this.loadClntAprlLst();

        this.closeLeadActionPopup();
      },
      error: (err) => {
        const message = err?.error?.error || err?.error?.message || this.translate.instant('LEAD_DASHBOARD.UNABLE_TO_PROCESS_LEAD');

        this.toastr.error(message);
        this.isLeadActionSubmitting = false;
      },
    });
  }

  onPopupConfirmed(): void {
    if (this.popupAction === 'send') {
      this.onSendConfirmed();
    }

    if (this.popupAction === 'approve') {
      this.onApproveConfirmed();
    }
  }

onApproveConfirmed(): void {
  if (!this.pendingLead) {
    return;
  }

  const lead = this.pendingLead;

  const payload: LeadStatusActionPayload = {
    entySeq: lead.id,
    entyType: this.currentModSeq,
    cmmnt: this.reviewComment.trim(),
  };

  this.leadService
    .leadApproved(payload)
    .subscribe({
      next: (res: any) => {
        if (
          res?.error ||
          res?.__hasError ||
          res?.success === false ||
          res?.status === false
        ) {
          this.toastr.error(
            res?.error ||
              res?.message ||
              this.translate.instant('LEAD_DASHBOARD.FAILED_TO_APPROVE_LEAD'),
          );

          return;
        }

        this.toastr.success(
          this.translate.instant('LEAD_DASHBOARD.LEAD_APPROVED_SUCCESSFULLY'),
        );

        this.clientApprovalLeads =
          this.clientApprovalLeads.filter(
            (item) => item.id !== lead.id,
          );

        this.showConfirmPopup = false;
        this.pendingLead = null;
        this.popupAction = null;

        this.getLeads();
        this.getLeadsCount();
        this.loadClntAprlLst();
      },

      error: (err) => {
        this.toastr.error(
          err?.error?.error ||
            err?.error?.message ||
            this.translate.instant('LEAD_DASHBOARD.FAILED_TO_APPROVE_LEAD'),
        );
      },
    });
}

  rejectLead(lead: Lead): void {
    if (!lead?.id) {
      this.toastr.error(this.translate.instant('LEAD_DASHBOARD.INVALID_LEAD'));
      return;
    }

    const payload: LeadStatusActionPayload = {
      entySeq: lead.id,
      entyType: this.currentModSeq,
      cmmnt: '',
    };

    this.leadService.rejectLead(payload).subscribe({
      next: (res: any) => {
        // ✅ handle logical error returned in 200
        if (res?.error) {
          this.toastr.error(res.error);
          return;
        }

        this.toastr.success(this.translate.instant('LEAD_DASHBOARD.LEAD_REJECTED'));

        // remove from approval list (UX)
        this.clientApprovalLeads = this.clientApprovalLeads.filter((l) => l.id !== lead.id);
      },
      error: (err) => {
        const msg = err?.error?.error || err?.error?.message || this.translate.instant('LEAD_DASHBOARD.FAILED_TO_REJECT_LEAD');

        this.toastr.error(msg);
      },
    });
  }

  addNewLead(): void {
    this.leadService.setLeadSeq(null);
    this.leadService.setLeadForm(null);
    this.router.navigate(['/add-new-leads/demographic']);
  }
  finalSendLead(): void {
    if (!this.pendingLead) {
      this.isReviewSubmitting = false;
      return;
    }

    const lead = this.pendingLead;

    const payload: LeadStatusActionPayload = {
      entySeq: lead.id,
      entyType: this.currentModSeq,
      cmmnt: this.reviewComment.trim(),
    };

    this.leadService.updateLeadStatus(payload).subscribe({
      next: (res: any) => {
        if (res?.error || res?.__hasError || res?.success === false || res?.status === false) {
          this.toastr.error(res?.error || res?.message || this.translate.instant('LEAD_DASHBOARD.FAILED_TO_SEND_LEAD'));
          this.isReviewSubmitting = false;
          return;
        }

        lead.status = 2;

        this.toastr.success(this.translate.instant('LEAD_DASHBOARD.REVIEW_SUBMITTED_SENT'));

        this.resetReviewState();

        this.getLeads();
        this.getLeadsCount();
        this.loadClntAprlLst();
      },
      error: (err) => {
        this.toastr.error(err?.error?.error || err?.error?.message || this.translate.instant('LEAD_DASHBOARD.NETWORK_SERVER_ERROR'));
        this.isReviewSubmitting = false;
      },
    });
  }
 

  finalApproveLead(): void {
  if (!this.pendingLead) {
    this.isReviewSubmitting = false;
    return;
  }

  const lead = this.pendingLead;

  const payload: LeadStatusActionPayload = {
    entySeq: lead.id,
    entyType: this.currentModSeq,
    cmmnt: this.reviewComment.trim(),
  };

  this.leadService
    .leadApproved(payload)
    .subscribe({
      next: (res: any) => {
        if (
          res?.error ||
          res?.__hasError ||
          res?.success === false ||
          res?.status === false
        ) {
          this.toastr.error(
            res?.error ||
              res?.message ||
              this.translate.instant('LEAD_DASHBOARD.FAILED_TO_APPROVE_LEAD'),
          );

          this.isReviewSubmitting = false;
          return;
        }

        this.toastr.success(
          this.translate.instant('LEAD_DASHBOARD.REVIEW_SUBMITTED_APPROVED'),
        );

        this.clientApprovalLeads =
          this.clientApprovalLeads.filter(
            (item) => item.id !== lead.id,
          );

        this.pendingApprovalLeads =
          this.pendingApprovalLeads.filter(
            (item) => item.id !== lead.id,
          );

        this.resetReviewState();

        this.getLeads();
        this.getLeadsCount();
        this.loadClntAprlLst();
      },

      error: (err) => {
        this.toastr.error(
          err?.error?.error ||
            err?.error?.message ||
            this.translate.instant('LEAD_DASHBOARD.FAILED_TO_APPROVE_LEAD'),
        );

        this.isReviewSubmitting = false;
      },
    });
}
}